import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from "react";

import { User } from "../../types/user";

type LoginUserContextType = {
  loginUser: User;
  setLoginUser: Dispatch<SetStateAction<User>>;
};

export const LoginUserContext = createContext<LoginUserContextType>(
  {} as LoginUserContextType
);

export const initUserObj = {
  username: '',
  email: '',
  userGroup: '',
  userKind: '',
  envType: process.env.REACT_APP_ENV_TYPE === undefined ? 'DEV' : process.env.REACT_APP_ENV_TYPE,
  eTime: Math.floor(new Date().getTime()/1000),
  token: '',
  param: {},
  issue_cloud_list: [],
  case_search_days: 0,
  group_search_days: 0,
  mypage_search_days: 0,
  mailgroup_search_days: 0,
  sfdc_url: '',
  bu_list: [],
  mailgroup_class_list: [],
  mailgroup_cloud_list: [],
  max_group_search_days: 0,
  max_issue_search_days: 0,
  max_case_search_days: 0,
  max_mail_search_days: 0,
  nec_network: false,
  necFlag: false,
  department: '',
  jobTitle: '',
};

// ログインユーザー情報を保持するcontext
export const LoginUserProvider = (props: { children: ReactNode }) => {
  const { children } = props;
  const [loginUser, setLoginUser] = useState<User>(initUserObj);

  return (
    <LoginUserContext.Provider value={{ loginUser, setLoginUser }}>
      {children}
    </LoginUserContext.Provider>
  );
};

export const useLoginUser = (): LoginUserContextType =>
  useContext(LoginUserContext);
